import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "chats";
const chatLogApi = {
  chatLogs(params: any): Promise<any> {
    const url = `${path}/messages`;
    return api.get(url, params);
  },

  chatGroupMessages(chat_id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/${chat_id}/members`;
    return api.get(url, params);
  },
};

export default chatLogApi;
